export function detectBrowserName(userAgent: string): string {
  const ua = userAgent || '';
  if (ua.includes('Edg/')) return 'Edge';
  if (ua.includes('OPR/')) return 'Opera';
  if (ua.includes('Chrome/')) return 'Chrome';
  if (ua.includes('Safari/') && !ua.includes('Chrome/')) return 'Safari';
  if (ua.includes('Firefox/')) return 'Firefox';
  if (/MSIE |Trident\//.test(ua)) return 'IE';
  return 'Unknown';
}

export function detectDeviceType(userAgent: string): 'mobile' | 'desktop' | 'tablet' {
  const ua = userAgent || '';
  if (/iPad|Tablet|PlayBook|Nexus 7|Nexus 10|SM-T|KFAPWI/i.test(ua)) return 'tablet';
  if (/Mobi|Android/i.test(ua)) return 'mobile';
  return 'desktop';
}

export function truncate(input: string | undefined | null, max: number): string | undefined {
  if (!input && input !== '') return undefined;
  const str = String(input);
  return str.length > max ? str.slice(0, max) : str;
}


